import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Input,
  Button,
  Select,
  Message,
  Card,
  Table,
  NumberPicker,
  Radio,
  Checkbox,
} from '@alifd/next';
import { Form } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const Option = Select.Option;
const MachineInspectList = () => {
  const [form] = Form.useForm();
  const communityDevice = client.service('communityDevice');
  const machineInspectResult = client.service('machineInspectResult');
  const [communityDeviceDialog, setCommunityDeviceDialog] = useState(false);
  const [checkListDialog, setCheckListDialog] = useState(false);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [communityDeviceDate, setCommunityDeviceDate] = useState([]);
  const [communityDeviceUpdate, setCommunityDeviceUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [isUpdate, setIsUpdate] = useState(false);
  const [checkListRecordDialog, setCheckListRecordDialog] = useState(false);
  const [checkListRecordArr, setCheckListRecordArr] = useState([]);

  useEffect(() => {
    communityDevice
      .find({ query: {} })
      .then((result) => {
        setCommunityDeviceArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    communityDevice
      .find({ query: { checkList: { $ne: null } } })
      .then((result) => {
        setCommunityDeviceDate(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isUpdate, communityDevice]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    if (communityDeviceStatus === 'insert') {
      const newDeviceObject = {
        checkList: value.checkList,
        checkNum: `${value.checkNum}${value.checkUnit}`,
        checkWeek: value.checkWeek,
      };
      console.log(value);
      communityDevice
        .patch(value.deviceId, { ...newDeviceObject })
        .then(() => {
          Message.success('新增成功');
          setCommunityDeviceDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      communityDevice
        .patch(communityDeviceUpdate._id, {
          checkList: null,
          checkNum: null,
          checkWeek: null,
        })
        .then(() => {
          const newDeviceObject = {
            checkList: value.checkList,
            checkNum: `${value.checkNum}${value.checkUnit}`,
            checkWeek: value.checkWeek,
          };
          communityDevice
            .patch(value.deviceId, { ...newDeviceObject })
            .then(() => {
              Message.success('修改成功');
              setCommunityDeviceDialog(false);
              setIsUpdate((pre) => !pre);
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          setCommunityDeviceDialog(true);
          setCommunityDeviceStatus('insert');
        }}
      >
        新增
      </Button>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={communityDeviceDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setCommunityDeviceDialog(false);
        }}
        onClose={() => {
          setCommunityDeviceDialog(false);
        }}
      >
        <h1>{communityDeviceStatus === 'insert' ? '新增' : '修改'}檢查項目</h1>
        <h3>可自行填寫檢查項目或勾選預設項目，並填寫工作週期！！</h3>

        <Form
          form={form}
          name="dynamic_form_item"
          onFinish={onFinish}
          {...formItemLayoutWithOutLabel}
          initialValues={
            communityDeviceUpdate?.deviceName
              ? {
                  deviceId: communityDeviceUpdate._id,
                  checkUnit: communityDeviceUpdate.checkNum.split('')[1],
                  checkNum: communityDeviceUpdate.checkNum.split('')[0],
                  checkList: communityDeviceUpdate.checkList,
                  checkWeek: communityDeviceUpdate.checkWeek,
                }
              : { checkNum: 0 }
          }
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇設備名稱',
              },
            ]}
            label="設備名稱"
            name="deviceId"
          >
            <Select
              className={styles.options}
              placeholder="請選擇設備名稱"
              aria-label="name is"
            >
              {communityDeviceArr.map((item) => (
                <Option value={item._id}>{item.deviceName}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="檢核週期"
            required={[{ required: true, message: '請選擇填選' }]}
            {...formItemLayout}
          >
            <div className={styles.workingBox}>
              每
              <Form.Item
                name="checkNum"
                noStyle
                rules={[
                  {
                    required: true,
                    message: '請選擇天數',
                  },
                ]}
              >
                <NumberPicker min={0} />
              </Form.Item>
              <Form.Item
                noStyle
                name="checkUnit"
                rules={[
                  {
                    required: true,
                    message: '請選擇時段',
                  },
                ]}
              >
                <Select hasClear placeholder="請選擇時段" aria-label="name is">
                  <Option value="週">週</Option>
                  <Option value="月">月</Option>
                  <Option value="年">年</Option>
                </Select>
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請勾選檢核星期',
              },
            ]}
            label="檢核星期"
            name="checkWeek"
          >
            <Checkbox.Group>
              <Checkbox value="一">星期一</Checkbox>
              <Checkbox value="二">星期二</Checkbox>
              <Checkbox value="三">星期三</Checkbox>
              <Checkbox value="四">星期四</Checkbox>
              <Checkbox value="五">星期五</Checkbox>
              <Checkbox value="六">星期六</Checkbox>
              <Checkbox value="日">星期日</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.List
            name="checkList"
            rules={[
              {
                validator: async (_, names) => {
                  if (!names || names.length < 1) {
                    return Promise.reject(new Error('檢核項目至少大於一題'));
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }, { errors }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item
                    {...(index === 0
                      ? formItemLayout
                      : formItemLayoutWithOutLabel)}
                    label={index === 0 ? '題目' : ''}
                    required={[{ required: true, message: 'Missing area' }]}
                    key={field.key}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={['onChange', 'onBlur']}
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: '請輸入題目',
                        },
                      ]}
                      noStyle
                    >
                      <Input
                        placeholder="passenger name"
                        style={{
                          width: '60%',
                        }}
                      />
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        onClick={() => remove(field.name)}
                      />
                    ) : null}
                  </Form.Item>
                ))}
                <Form.Item>
                  <Button
                    type="normal"
                    onClick={() => add()}
                    style={{
                      width: '60%',
                    }}
                    icons={<PlusOutlined />}
                  >
                    新增檢核項目
                  </Button>
                  <Form.ErrorList errors={errors} />
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={communityDeviceDate}>
            <Table.Column title="設備名稱" dataIndex="deviceName" width={100} />
            <Table.Column
              title="設備編號"
              dataIndex="deviceNumber"
              width={200}
            />
            <Table.Column
              title="設備檢核週期"
              dataIndex="checkNum"
              width={200}
              cell={(value, _index, record) => {
                const check = value.split('/');
                return (
                  <>
                    每{check[1]}
                    {check[0]}固定星期{record.checkWeek.join('、')}
                  </>
                );
              }}
            />
            <Table.Column
              title="維護廠商"
              width={100}
              cell={(_value, _index, record) => record.deviceVendor[0].name}
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                return (
                  <div className={styles.btn}>
                    <Button
                      type="normal"
                      onClick={() => {
                        setCheckListDialog(true);
                        setCommunityDeviceUpdate(record);
                      }}
                    >
                      查看檢核表
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setCheckListRecordDialog(true);
                        machineInspectResult
                          .find({ query: { deviceId: record._id.toString() } })
                          .then((res) => {
                            setCheckListRecordArr(res.data);
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                        setCommunityDeviceUpdate(record);
                      }}
                    >
                      查看檢核記錄
                    </Button>
                    <Button
                      type="normal"
                      onClick={() => {
                        setCommunityDeviceStatus('update');
                        setCommunityDeviceUpdate(record);
                        setCommunityDeviceDialog(true);
                      }}
                    >
                      編輯
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        communityDevice
                          .patch(record._id, {
                            checkList: null,
                            checkNum: null,
                            checkWeek: null,
                          })
                          .then(() => {
                            Message.success('刪除成功');
                            setIsUpdate((pre) => !pre);
                          })
                          .catch((error) => console.log(error));
                      }}
                      warning
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>
        </Card.Content>
      </Card>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={checkListDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setCheckListDialog(false);
        }}
        onClose={() => {
          setCheckListDialog(false);
        }}
      >
        <h1>{communityDeviceUpdate.deviceName}巡檢表</h1>
        {communityDeviceUpdate.checkList &&
          communityDeviceUpdate.checkList.map((item, index) => (
            <>
              <div className={styles.checkList}>
                <div className={styles.checkListTitle}>
                  檢核項目{index + 1}：
                </div>
                <div className={styles.checkListContent}>{item}</div>
              </div>
              <div className={styles.checkList}>
                <RadioGroup aria-labelledby="groupId">
                  <Radio id="良" value="良">
                    良好
                  </Radio>
                  <Radio id="普" value="普">
                    普通
                  </Radio>
                  <Radio id="劣" value="劣">
                    劣等
                  </Radio>
                </RadioGroup>
              </div>
            </>
          ))}
        <div className={styles.checkList}>
          <div className={styles.checkListTitle}>備註：</div>
        </div>
        <div className={styles.checkList}>
          <Input.TextArea
            style={{ width: 300 }}
            placeholder="TextArea"
            maxLength={100}
            rows={4}
            showlimithint
            aria-label="input max length 100"
          />
        </div>
      </Dialog>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={checkListRecordDialog}
        onOk={() => {
          setCheckListRecordDialog(false);
        }}
        onCancel={() => {
          setCheckListRecordDialog(false);
        }}
        onClose={() => {
          setCheckListRecordDialog(false);
        }}
      >
        <h1>{communityDeviceUpdate.deviceName}檢核狀況</h1>
        {checkListRecordArr.length > 0 && (
          <Table dataSource={checkListRecordArr}>
            <Table.Column
              title="巡察時間"
              dataIndex="createdTime"
              width={150}
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column title="設備狀況" dataIndex="summary" width={100} />
            <Table.Column title="檢核人員" dataIndex="inspector" width={100} />
          </Table>
        )}
      </Dialog>
    </>
  );
};

export default MachineInspectList;
